import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { Accordion, AccordionTab } from 'primereact/accordion';

import ChatterSettings from 'components/ChatterSettings';

const OnlineChatterList = (props) => {
  const [me, setMe] = useState(null);
  const [chatters, setChatters] = useState([]);
  const [selectedChatters, setSelectedChatters] = useState(null);
  const [mutedChatterIds, setMutedChatterIds] = useState([]);
  const [chatterSettings, setChatterSettings] = useState(null);

  useEffect(() => {
    // Me
    var tmpMe = null;
    if (Cookies.get('chatter') === undefined) {
      return (() => {});
    } else {
      tmpMe = JSON.parse(Cookies.get('chatter'));
      setMe(tmpMe);
    }
    // online chatters
    setChatters(props.chatters.filter((chatter) => {
      return chatter.chatter_id !== tmpMe?.chatter_id ?? '';
    }));
    // selected chatter
    setSelectedChatters(props.selectedChatterId ?? null);
    // muted chatters
    setMutedChatterIds(props.mutedChatterIds ?? []);
    // chatter settings
    setChatterSettings(props.chatterSettings ?? null);
  }, [props]);

  const updateSettings = (updatedChatterSettings) => {
    props.onUpdateChatterSettings(updatedChatterSettings);
  };

  return (
    <>
      <div className="online-chatter-panel flex flex-column gap-2 h-full">
        <div className="me-container">
          <div className="me-container-inner flex flex-column border-round-lg chatroom-surface-100">
            <Accordion>
              <AccordionTab header={me === null ? <></> : 
                <div className="flex flex-row align-items-center gap-2">
                  <div className="avatar self-align-center">
                    <Image src={`/avatar/${me.avatar}.jpg`} alt="Image" width="60" imageClassName="border-circle block" />
                  </div>
                  <div className="nickname text-xl">
                    {me.nickname}
                  </div>
                </div>
              }>
                <ChatterSettings onLogout={props.onLogout} chatterSettings={chatterSettings} onUpdateChatterSettings={updateSettings} />
              </AccordionTab>
            </Accordion>
          </div>
        </div>
        <div className="chatter-list-container flex-1 h-1rem">
          <div className="chatter-list-inner flex flex-column h-full border-round-lg chatroom-surface-100">
            {/* <div className="text-lg font-bold p-2 bg-primary text-white border-round-top-lg">👤 在線用戶 ({chatters.length})</div> */}
            <div className="chatters flex flex-column overflow-y-auto py-2">
              <a href="#" onClick={() => props.onSelectChatter(null)} className={`chatter flex flex-row justify-content-between align-items-center px-3 py-2 chatroom-text-800 no-underline ${selectedChatters===null?'selected':''}`} key="0">
                <div className="nickname flex flex-row align-items-center gap-2">
                  <div className="avatar">
                    <Image src={`/favicon.png`} alt="Image" width="24" imageClassName="block" />
                  </div>
                  <div className="nickname">
                    聊天大廳
                  </div>
                </div>
                <div className="tools"></div>
              </a>
              {props.chatters.length === 0 ? <></> : chatters.length === 0 ?
                <>
                  <div className="p-4 text-center">聊天室暫時未有其他人😿</div>
                </>
              :
                chatters.map((chatter) => {
                  return (
                    <a href="#" onClick={() => props.onSelectChatter(chatter.chatter_id)} className={`chatter flex flex-row justify-content-between align-items-center px-3 py-2 chatroom-text-800 no-underline ${selectedChatters===chatter.chatter_id?'selected':''}`} key={chatter.chatter_id}>
                      <div className="nickname flex flex-row align-items-center gap-2">
                        <div className="avatar">
                          <Image src={`/avatar/${chatter.avatar}.jpg`} alt="Image" width="24" imageClassName="border-circle block" />
                        </div>
                        <div className={`nickname ${chatter.offline?'line-through':''}`}>
                          {chatter.nickname}
                        </div>
                      </div>
                      <div className="tools">
                        {mutedChatterIds.includes(chatter.chatter_id) && <div className="chatter-list-muted-icon"><i className="pi pi-volume-off" style={{ fontSize: '0.8rem' }}></i></div>}
                      </div>
                    </a>
                  );
                })
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
  
export default OnlineChatterList;
